<script setup>
import InvoiceFilters from '../../components/forms/filters/Invoice';
import InvoicesTable from '../../components/table/Invoices';
</script>

<template>
  <div data-view="invoices">
     <!-- route to popup [[src/components/dialog/creatorProgram/Invoice.vue]] -->
    <!-- All popups will appear here -->
    <router-view />

    <layout-logged-frame :title="$t('invoices')">
      <template v-slot:content>
        <InvoiceFilters
          @filter="onFilter"
          @clearFilters="onClearFilters"
        />

        <InvoicesTable
          :items="invoices"
          :pagination="pagination"
          :is-loading="isLoading"
          :pages="totalPages"
          :on-select-item="selectItem"
          :on-update-pagination="onUpdatePagination"
          :on-change-page="onChangePage"
        />
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
import { isStr } from '@/utils';

export default {
  data() {
    return {
      pagination: {
        order: 'desc' ,
        page: 1,
        rowsPerPage: 15,
        sortBy: 'created_at',
        totalItems: 0,
        search: '',
      },
      totalPages: 0,
      query: {
        per_page: 15,
      },
      isLoading: false,
    };
  },
  computed: {
    invoices() {
      return this.$store.getters['creatorProgram/invoices'];
    },
  },
  methods: {
    getInvoices() {
      this.isLoading = true;
      this.pagination.order = this.query.order;

      return this.$store
        .dispatch('creatorProgram/getInvoices', this.query)
        .then((res) => {
          const { total, current_page, last_page } = res.meta;

          this.pagination.page = current_page;
          this.pagination.totalItems = total;
          this.totalPages = last_page;
          this.isLoading = false;

          return res;
        })
        .catch((err) => {
          this.isLoading = false;
          return err;
        });
    },
    selectItem(invoice) {
      this.$store.dispatch('creatorProgram/setActiveInvoice', invoice).then(() => {
        this.$router.push({name: 'creator-program-invoices-details', params: {id: invoice.id}});
      });
    },
    onUpdatePagination({ page, order, sortBy }) {
      const { query, pagination } = this;
      this.pagination.order = order;
      this.pagination.sortBy = isStr(sortBy) ? sortBy : pagination.sortBy;

      const nextQuery = {
        ...query,
        page,
        order,
        sort: isStr(sortBy) ? sortBy : pagination.sortBy,
      };

      this.query = nextQuery;
      this.getInvoices();
    },
    onChangePage(page) {
      const { query, pagination } = this;
      const { order, sortBy } = pagination;
      const nextQuery = {
        ...query,
        page,
        order,
        sort: sortBy,
      };

      this.query = nextQuery;
      this.getInvoices();
    },
    onFilter(filters) {
      this.query = {
        ...this.query,
        ...filters,
        page: 1,
      };

      this.getInvoices();
    },
    onClearFilters() {
      const { sortBy, order } = this.pagination;
      this.query = { sort: sortBy, order, per_page: 15, page: 1 };
      this.getInvoices();
    },
  },
};
</script>

<style lang="scss">
@use '../../assets/styles/theme' as *;

[data-view='invoices'] {
  .trigger.download-pdf {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .v-icon {
      margin: 0 6px 0 0;
    }
  }

  .v-datatable {
    min-width: $table-min-width;
  }
}
</style>
